import React, { useEffect, useRef, useState } from 'react';
import './BrandingLayout.css';

const FEATURES = [
  {
    id: 'verified',
    title: 'Verified referrers only',
    text: 'Every referrer is a real, active employee. Profiles are checked before any referral is accepted.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M12 2l7 3v6c0 4.5-3 8-7 9-4-1-7-4.5-7-9V5z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    ),
  },
  {
    id: 'private',
    title: 'Your data stays private',
    text: 'We never share your details without consent. Requests reach the employee directly — no middleman.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <rect x="4" y="10" width="16" height="10" rx="2" />
        <path d="M8 10V7a4 4 0 0 1 8 0v3" />
      </svg>
    ),
  },
  {
    id: 'transparent',
    title: 'Transparent by design',
    text: 'Track every request in real time. Full visibility at each step with no hidden fees and no guesswork.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    ),
  },
] as const;

const BrandingLayout: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2, rootMargin: '0px 0px -50px 0px' }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className={`branding-section ${isVisible ? 'branding-visible' : ''}`}>
      <div className="branding-container">
        <div className="branding-top">
          <h2 className="branding-title branding-animate-left">
            Built on trust and
            <br />
            verified referrals
          </h2>

          <div className="branding-grid branding-animate-right">
            {FEATURES.map((item) => (
              <article className="branding-item" key={item.id}>
                <span className="branding-item-icon">{item.icon}</span>
                <h3 className="branding-item-title">{item.title}</h3>
                <p className="branding-item-text">{item.text}</p>
              </article>
            ))}
          </div>
        </div>

        <div className="branding-foot">
          <p className="branding-disclaimer">
            Reffconnect is a referral marketplace connecting job seekers with verified professionals.
            Referrals do not guarantee interviews or offers; hiring outcomes remain the independent
            decision of each employer.
          </p>
          <p className="branding-powered">
            Powered by <span className="branding-powered-brand">Reffconnect</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default BrandingLayout;
